import { GRAPH_COLORS } from '../../constants';

export const getGraphColors = (numberOfItems: number) => {
  let colors;
  switch (numberOfItems) {
    case 1:
      colors = [GRAPH_COLORS[6]];
      break;
    case 2:
      colors = [GRAPH_COLORS[5], GRAPH_COLORS[10]];
      break;
    case 3:
      colors = [GRAPH_COLORS[0], GRAPH_COLORS[6], GRAPH_COLORS[14]];
      break;
    case 4:
      colors = [
        GRAPH_COLORS[0],
        GRAPH_COLORS[4],
        GRAPH_COLORS[9],
        GRAPH_COLORS[14],
      ];
      break;
    case 5:
      colors = [
        GRAPH_COLORS[0],
        GRAPH_COLORS[3],
        GRAPH_COLORS[6],
        GRAPH_COLORS[9],
        GRAPH_COLORS[14],
      ];
      break;
    case 6:
      colors = [
        GRAPH_COLORS[0],
        GRAPH_COLORS[3],
        GRAPH_COLORS[6],
        GRAPH_COLORS[9],
        GRAPH_COLORS[12],
        GRAPH_COLORS[14],
      ];
      break;
    case 7:
      colors = [
        GRAPH_COLORS[0],
        GRAPH_COLORS[2],
        GRAPH_COLORS[5],
        GRAPH_COLORS[7],
        GRAPH_COLORS[9],
        GRAPH_COLORS[11],
        GRAPH_COLORS[14],
      ];
      break;
    case 8:
      colors = [
        GRAPH_COLORS[0],
        GRAPH_COLORS[2],
        GRAPH_COLORS[4],
        GRAPH_COLORS[6],
        GRAPH_COLORS[8],
        GRAPH_COLORS[10],
        GRAPH_COLORS[12],
        GRAPH_COLORS[14],
      ];
      break;
    case 9:
      colors = [
        GRAPH_COLORS[0],
        GRAPH_COLORS[2],
        GRAPH_COLORS[4],
        GRAPH_COLORS[6],
        GRAPH_COLORS[7],
        GRAPH_COLORS[9],
        GRAPH_COLORS[11],
        GRAPH_COLORS[12],
        GRAPH_COLORS[14],
      ];
      break;
    case 10:
      colors = [
        GRAPH_COLORS[0],
        GRAPH_COLORS[2],
        GRAPH_COLORS[3],
        GRAPH_COLORS[4],
        GRAPH_COLORS[6],
        GRAPH_COLORS[7],
        GRAPH_COLORS[9],
        GRAPH_COLORS[11],
        GRAPH_COLORS[12],
        GRAPH_COLORS[14],
      ];
      break;
    case 11:
      colors = [
        GRAPH_COLORS[0],
        GRAPH_COLORS[1],
        GRAPH_COLORS[2],
        GRAPH_COLORS[3],
        GRAPH_COLORS[4],
        GRAPH_COLORS[6],
        GRAPH_COLORS[7],
        GRAPH_COLORS[9],
        GRAPH_COLORS[11],
        GRAPH_COLORS[12],
        GRAPH_COLORS[14],
      ];
      break;
    case 12:
      colors = [
        GRAPH_COLORS[0],
        GRAPH_COLORS[1],
        GRAPH_COLORS[2],
        GRAPH_COLORS[3],
        GRAPH_COLORS[4],
        GRAPH_COLORS[6],
        GRAPH_COLORS[7],
        GRAPH_COLORS[8],
        GRAPH_COLORS[9],
        GRAPH_COLORS[11],
        GRAPH_COLORS[12],
        GRAPH_COLORS[14],
      ];
      break;
    case 13:
      colors = [
        GRAPH_COLORS[0],
        GRAPH_COLORS[1],
        GRAPH_COLORS[2],
        GRAPH_COLORS[3],
        GRAPH_COLORS[4],
        GRAPH_COLORS[6],
        GRAPH_COLORS[7],
        GRAPH_COLORS[8],
        GRAPH_COLORS[9],
        GRAPH_COLORS[11],
        GRAPH_COLORS[12],
        GRAPH_COLORS[13],
        GRAPH_COLORS[14],
      ];
      break;
    case 14:
      colors = [
        GRAPH_COLORS[0],
        GRAPH_COLORS[1],
        GRAPH_COLORS[2],
        GRAPH_COLORS[3],
        GRAPH_COLORS[4],
        GRAPH_COLORS[5],
        GRAPH_COLORS[6],
        GRAPH_COLORS[7],
        GRAPH_COLORS[8],
        GRAPH_COLORS[9],
        GRAPH_COLORS[11],
        GRAPH_COLORS[12],
        GRAPH_COLORS[13],
        GRAPH_COLORS[14],
      ];
      break;
    default:
      return GRAPH_COLORS;
      break;
  }
  return colors;
};
